import { Injectable, Inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageViewService {
  constructor(@Inject('ServiceByType') private ServiceByType: any) {}

  addPageView(type: string, id: number): Promise<any> {
    return this.ServiceByType.get(type).addPageView(id);
  }
}
